import React from 'react'

// Design
const Dashboard = () => {
    return (
        <div>
            hello
        </div>
    )
}

export default Dashboard
